import { useEffect, useState, useCallback, memo } from 'react'
// import PropTypes from 'prop-types'
import { Box, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
// import moment from 'moment'
import { alog } from 'src/utils/apioLog'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
// import { updateAnomaliesData, updatedDeselected, anomaliesLimit, getAnomaliesDevices } from 'src/slices/plantView'
import useAuth from 'src/hooks/useAuth'
import api from 'src/utils/api'
import { useSnackbar } from 'notistack'
// import axios from 'src/utils/axios'
// import useIsMountedRef from 'src/hooks/useIsMountedRef'
// import PerfectScrollbar from 'react-perfect-scrollbar'
import ReportTable from 'src/components/Report/ReportTable'
import ReportEmails from 'src/components/Report/ReportEmails'
import SendEmails from 'src/components/Report/SendEmails'
import PlantReportSidenav from 'src/components/Report/PlantReportSidenav'
// import { getDatesFromPeriod } from '../utils'

// STILI DEL COMPONENTE
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%'
  },
  section: {
    padding: theme.spacing(1, 2),
    width: '100%',
    height: '100%'
  },
  sectionTitle: {
    textTransform: 'uppercase',
    color: theme.palette.primary.main
  },
  topMargin: {
    marginTop: (theme.spacing(2) - 4)
  },
  smallViewport: {
    overflowY: 'auto',
    height: '100%'
  }
}))

// COMPONENTE PRINCIPALE
const Report = ({ className, ...rest }) => {
  const classes = useStyles()
  const { plantId } = useParams()
  const { user, updateReportEmails } = useAuth()
  // alog('user', user, 'report')
  const { enqueueSnackbar } = useSnackbar()
  const { name } = useSelector((state) => state.pvPlantView)
  // alog('reportConfig', reportConfig, 'report')
  // const dispatch = useDispatch()
  // variaibli principali
  const [reports, setReports] = useState(['-'])
  const [refreshReports, setRefreshReports] = useState(true)
  // const [periods, setPeriods] = useState([])
  const [openSendReport, setOpenSendReport] = useState(false)
  const [openReportEmails, setOpenReportEmails] = useState(false)
  const [openReport, setOpenReport] = useState(false)
  const [reportToEdit, setReportToEdit] = useState(null)

  const getData = useCallback(async (plantId) => {
    alog('dentro getData', null, 'report')
    try {
      const reportParams = {
        type: 'plant',
        plantId: plantId
      }
      const reportResponse = await api.getResource('reports', { params: reportParams })
      // alog('reportResponse =>', reportResponse, 'report')
      const dataObj = reportResponse
      alog('report data', dataObj, 'report')
      return dataObj
    } catch (err) {
      alog('Error getData reports =>', err, 'error')
      return null
    }
  }, [])

  useEffect(() => {
    // console.log('dentro useEffect')
    async function initialiseView () {
      const data = await getData(plantId)
      if (data) {
        // const periods = data.map(report => `${report.month}${report.year}`)
        // setPeriods(periods)
        // alog('new periods =>', periods, 'report')
        setReports(data)
      } else {
        setReports([])
      }
      setRefreshReports(false)
    }
    // se devo refreshare la view lo faccio qui
    if (refreshReports) {
      initialiseView()
    }
    // setto interval
    const reportInterval = setInterval(() => {
      console.log('dentro interval')
      initialiseView()
    }, 60000)
    return () => {
      clearInterval(reportInterval)
    }
  }, [refreshReports, getData, plantId])

  // funzione che apre la sidenav per creare un nuovo report
  const openNewReport = (report) => {
    alog('openNewReport', null, 'report')
    if (report) {
      setReportToEdit(report)
    } else {
      setReportToEdit(null)
    }
    setOpenReport(true)
  }

  // funzione lanciata al save del nuovo Report
  const saveNewReport = async (newReport) => {
    alog('saveNewReport, newReport =>', newReport, 'report')
    // controllo se è un report che ho già creato, lo edito
    const thisIndex = reports.findIndex(report => {
      // return periods.indexOf(`${newReport.month}${newReport.year}`) > -1
      return newReport.month === report.month && newReport.year === report.year
    })
    if (thisIndex > -1) {
      // alog('reports index =>', thisIndex, 'report')
      const toSend = {
        ...reports[thisIndex],
        notes: newReport.notes,
        plantStatus: newReport.plantStatus,
        plantStatusNotes: newReport.plantStatusNotes
      }
      editReport(toSend)
      return
    }
    try {
      await api.postResource('reports', { body: newReport })
      enqueueSnackbar('Richiesta inviata, il Report sarà pronto a breve!', { variant: 'success' })
      // chiudo la modal
      setTimeout(() => {
        handleCloseNewReport()
        setRefreshReports(true)
      }, 2000)
    } catch (err) {
      console.error('Error while sending new report, err => ', err)
      enqueueSnackbar("Errore durante l'invio del nuovo report. Per favore riprovare", { variant: 'error' })
    }
  }

  // funzione lanciata al save delle modifiche sul report
  const editReport = async (newReport) => {
    alog('editReport, report =>', newReport, 'report')
    try {
      await api.putResource('reports', { path: `/${newReport.uuid}`, body: newReport })
      enqueueSnackbar('Richiesta di modifica inviata, il Report sarà pronto a breve!', { variant: 'success' })
      // chiudo la modal
      setTimeout(() => {
        handleCloseNewReport()
        setRefreshReports(true)
      }, 2000)
    } catch (err) {
      console.error('Error while sending new report, err => ', err)
      enqueueSnackbar("Errore durante l'invio del report modificato. Per favore riprovare", { variant: 'error' })
    }
  }

  // funzione lanciata al save delle modifiche sul report
  const deleteReport = async (report) => {
    alog('deleteReport, newReport =>', report, 'report')
    try {
      await api.deleteResource('reports', { path: `/${report.uuid}` })
      enqueueSnackbar('Report eliminato correttamente!', { variant: 'success' })
      setRefreshReports(true)
    } catch (err) {
      console.error('Error while sending new report, err => ', err)
      enqueueSnackbar("Errore durante l'eliminazione del report. Per favore riprovare", { variant: 'error' })
    }
  }

  // funzione lanciata al close della sidenav della creazione / modifica
  const handleCloseNewReport = () => {
    // alog('handleCloseNewReport', null, 'report')
    setOpenReport(false)
  }

  // funzione che apre la modal per salvare le mail a cui inviare i report
  const openEditReportsMail = () => {
    alog('openEditReportsMail', null, 'report')
    setOpenReportEmails(true)
  }

  // funzione che salva le email per il Report
  const saveNewEmails = async (newEmails) => {
    alog('saveNewEmails, newEmails =>', newEmails, 'report')
    updateReportEmails(newEmails)
    const newMetadata = {
      ...user.metadata,
      reportEmails: newEmails
    }
    const newUser = {
      ...user,
      metadata: newMetadata
    }
    try {
      await api.putResource('accounts', { path: '/self', body: newUser })
      enqueueSnackbar('Email aggiornate con successo!', { variant: 'success' })
      // chiudo la modal
      setTimeout(() => {
        handleCloseReportEmails()
      }, 2000)
    } catch (err) {
      console.error('Error while updating self, err => ', err)
      enqueueSnackbar("Errore durante l'aggiornamento delle email. Per favore riprovare", { variant: 'error' })
    }
  }

  // funzione lanciata al close della modal delle email salvate
  const handleCloseReportEmails = () => {
    alog('handleCloseReportEmails =>', 'report')
    setOpenReportEmails(false)
  }

  // funzione che apre la modal per inviare il report
  const openSendPlantReport = (report) => {
    alog('openSendPlantReport, report', report, 'reports')
    setReportToEdit(report)
    setOpenSendReport(true)
  }

  // funzione che invia i Report
  const sendEmails = async (emails) => {
    alog('sendEmails, emails =>', emails, 'reports')
    // mi preparo il body
    const body = {
      recipients: emails
    }

    try {
      await api.postResource('reports', { path: `/${reportToEdit.uuid}/email/send`, body: body })
      enqueueSnackbar('Richiesta invio email ricevuta, saranno inviate a breve!', { variant: 'success' })
      // chiudo la modal
      setTimeout(() => {
        handleCloseSendEmails()
      }, 1600)
    } catch (err) {
      console.error('Error while updating self, err => ', err)
      enqueueSnackbar('Errore durante la richiesta di invio. Per favore riprovare', { variant: 'error' })
    }
  }

  // funzione lanciata al close della modal dell'invio report
  const handleCloseSendEmails = () => {
    // alog('handleCloseReportEmails =>', null, 'reports')
    setOpenSendReport(false)
    setReportToEdit(null)
  }

  return (
    <div className={clsx(classes.root, className, classes.smallViewport)} {...rest}>
      <Box mt={2}>
        <ReportTable
          reports={reports}
          isLoading={refreshReports || reports[0] === '-'}
          // setRefreshReports={setRefreshReports}
          openEditReportsMail={openEditReportsMail}
          openNewReport={openNewReport}
          openEditReport={openNewReport}
          deleteReport={deleteReport}
          openSendReport={openSendPlantReport}
        />
      </Box>
      <ReportEmails
        open={openReportEmails}
        onClose={handleCloseReportEmails}
        emails={user.metadata.reportEmails}
        saveNewEmails={saveNewEmails}
      />
      <SendEmails
        open={openSendReport}
        onClose={handleCloseSendEmails}
        emails={user.metadata.reportEmails}
        sendEmails={sendEmails}
      />
      <PlantReportSidenav
        open={openReport}
        plantName={name}
        plantId={plantId}
        // periods={periods}
        reportToEdit={reportToEdit}
        onEdit={editReport}
        onSave={saveNewReport}
        onClose={handleCloseNewReport}
      />
    </div>
  )
}

export default memo(Report)
